export const STREAM_UPDATE_TOKENS_STORAGE_KEY = 'update_tokens_v3';

export const STREAM_ABORTED_ERROR = 'STREAM_UPDATES_ABORTED';

// `code` in the body of a 410 from /api/v3/stream/updates/{entity}: the server no longer knows
// the cursor we sent. It says nothing about the session itself.
export const STREAM_TOKEN_NOT_FOUND_CODE = 'stream_token_not_found';
